<template>
  <img class="bild-karte" :class="clsKarte" :style="styKarte" :src="imgKarte" />
</template>

<script setup>
  import { ref, computed, inject } from 'vue';
  import {karten} from '@/helper/karten';

  const props = defineProps({
    bild: String,
  });
  const image = ref(null);
  const faktor = inject('groesse');
  defineEmits(['stein-aktiv'])
	const imgKarte = computed(() => {
    const key = props.bild.substring(0,3);
    return karten[key.charAt(0) === 'v' ? 'verso' : key]
  });
  const styKarte = computed(() => 'border-radius:' + (faktor.value * 2) + 'px');
  const clsKarte = computed(() => (props.bild.charAt(3) === '2' || props.bild.charAt(3) === '3' ? 'selected' : ''));

</script>

